import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@smarterservices/smarter-ui';

/**
 * Transparent layout component with no background styling
 * 
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render within the layout
 * @returns {React.ReactElement} Layout with transparent background
 */
const TransparentLayout = ({ children }) => {
  return (
    <View as="div" className="main-content" background="transparent">
      {children}
    </View>
  );
};

TransparentLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TransparentLayout;